import { NgModule } from '@angular/core';

import { SharedModule} from "../../shared/shared.module";
import { AreasComponent } from './areas.component';
import { AreaListComponent } from './area-list/area-list.component';
import { AreaFormComponent } from './area-form/area-form.component';
import { AreaService } from "./shared/area.service";
import { AreaApiService } from "./shared/area-api.service";
import { AreaNavigationService } from "./shared/area-navigation.service";
import { AreasRoutingModule} from "./areas-routing.module";
import { AreaContatoApiService } from "./area-contatos/area-contato-api.service";
import { ContatosModule } from "../../recursos-humanos/contatos/contatos.module";

@NgModule({
  imports: [
    SharedModule,
    ContatosModule,
    AreasRoutingModule
  ],
  providers: [
    AreaService,
    AreaApiService,
    AreaNavigationService,
    AreaContatoApiService
  ],
  declarations: [
    AreasComponent,
    AreaListComponent,
    AreaFormComponent
  ],
  exports: [
    AreaListComponent
  ]
})
export class AreasModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/areas/areas.module.ts
 **/